// extracted by mini-css-extract-plugin
module.exports = {"galleryErrorPage":"GalleryErrorPage_galleryErrorPage__D9t87","galleryErrorPageExtended":"GalleryErrorPage_galleryErrorPageExtended__pxzKC"};